import { useEffect, useState } from 'react';
import { fetchBrandSettings } from '../api';

let cachedSettings = null;
let settingsRequest = null;

function loadBrandSettings() {
  if (cachedSettings) return Promise.resolve(cachedSettings);
  if (!settingsRequest) {
    settingsRequest = fetchBrandSettings()
      .then((settings) => {
        cachedSettings = settings;
        return settings;
      })
      .finally(() => {
        settingsRequest = null;
      });
  }
  return settingsRequest;
}

export function useBrandSettings() {
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    if (settings) return undefined;
    let cancelled = false;
    loadBrandSettings()
      .then((loadedSettings) => {
        if (!cancelled) setSettings(loadedSettings);
      })
      .catch((error) => {
        // Branding is optional; the fixed Keolis logo remains visible.
        console.warn('[Brand] Failed to load brand settings.', error);
      });
    return () => {
      cancelled = true;
    };
  }, [settings]);

  return settings;
}
